import { ReactNode } from 'react'
import styles from '../shared-ui-footer.module.css'
import { trackFooterLinkClick } from '../tracking'

export type SocialNetworkButtonProps = {
  icon: ReactNode
  link: string
  name: string
}

export const SocialNetworkButton = ({
  icon,
  link,
  name,
}: SocialNetworkButtonProps) => (
  <a
    href={link}
    className={styles.link}
    onClick={() => trackFooterLinkClick(link, name)}
    rel="noopener noreferrer"
    target="_blank"
    aria-label={name}
  >
    {icon}
  </a>
)
